import CompanyClientDetailContent from "../../features/companyClients/widgets/CompanyClientDetailContent";

function CompanyClientDetailScreen() {
  return <CompanyClientDetailContent />;
}

export default CompanyClientDetailScreen;
